var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.5 31.4",
    style: {
      enableBackground: "new 0 0 25.5 31.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AB9834;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.2,9.4l-0.7-7.5c-0.1-0.6-0.6-1.1-1.2-1.1H3.7c-0.6,0-1.1,0.5-1.2,1.1L1.7,9.4V10c0,2.4,1.4,4.4,3.4,5.2 v14.3c0,0.6,0.5,1.1,1.2,1.1h2.5c0.7,0,1.2-0.5,1.2-1.1V15.1C12.2,14.1,13.6,11.9,13.2,9.4z M8.8,29.6H6.3V15.7h2.5V29.6z M8.1,14.5 H7.6C5,14.5,3,12.5,3,10V9.5L3.7,2h1.4v6.9c0,0.4,0.2,0.6,0.6,0.6c0.4,0,0.6-0.2,0.6-0.6V2h2.5v6.9c0,0.4,0.2,0.6,0.6,0.6 c0.4,0,0.6-0.2,0.6-0.6V2h1.1l0.9,7.5C12.3,12,10.6,14.2,8.1,14.5z M20,30.7h2.5c0.7,0,1.2-0.5,1.2-1.2V2c0-0.6-0.5-1.1-1.1-1.2 c-2-0.2-3.4,0.2-3.9,1.6c-1.2,2.5-2.5,8.5-2.5,14c0.1,2.5,1,4.2,2.5,5v8.1C18.8,30.2,19.3,30.7,20,30.7z M17.6,16.4 c0-5.2,1.1-11.1,2.4-13.5c0.4-0.9,1.1-1.1,2.6-1v27.6H20V21c0-0.2-0.1-0.5-0.4-0.6C18.3,19.9,17.7,18.6,17.6,16.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDining);
export default __webpack_public_path__ + "static/media/footer-dining.a96f010d57f658d577fbfba659cad1ea.svg";
export { ForwardRef as ReactComponent };